import * as actions from "store/actions/nfse";
import INFSe from "Types/INFSe";

export interface NFSeState {
	items: INFSe[];
	filter: any[];
	pages: any;
	count: number;
	loading: {
		getAll: boolean;
		import: boolean;
		download: boolean;
		cancel: boolean;
	};
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: NFSeState = {
	items: [],
	filter: [],
	pages: null,
	count: 0,
	loading: { getAll: false, import: false, download: false, cancel: false },
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.GET_NFSES: {
			return {
				...state,
				loading: { ...state.loading, getAll: true },
				errors: initialState.errors
			};
		}
		case actions.GET_NFSES_SUCCESS: {
			return {
				...state,
				items: payload || [],
				loading: { ...state.loading, getAll: false }
			};
		}
		case actions.GET_NFSES_FAILED: {
			return {
				...state,
				loading: { ...state.loading, getAll: false },
				errors: payload
			};
		}
		case actions.IMPORT_NFSES: {
			return {
				...state,
				loading: { ...state.loading, import: true },
				errors: initialState.errors
			};
		}
		case actions.IMPORT_NFSES_SUCCESS: {
			return {
				...state,
				loading: { ...state.loading, import: false }
			};
		}
		case actions.IMPORT_NFSES_FAILED: {
			return {
				...state,
				loading: { ...state.loading, import: false },
				errors: payload
			};
		}
		case actions.DOWNLOAD_NFSES: {
			return {
				...state,
				loading: { ...state.loading, download: true },
				errors: initialState.errors
			};
		}
		case actions.DOWNLOAD_NFSES_SUCCESS: {
			return {
				...state,
				loading: { ...state.loading, download: false }
			};
		}
		case actions.DOWNLOAD_NFSES_FAILED: {
			return {
				...state,
				loading: { ...state.loading, download: false },
				errors: payload
			};
		}
		case actions.CANCEL_NFSE: {
			return {
				...state,
				loading: { ...state.loading, cancel: true },
				errors: initialState.errors
			};
		}
		case actions.CANCEL_NFSE_SUCCESS: {
			return {
				...state,
				loading: { ...state.loading, cancel: false }
			};
		}
		case actions.CANCEL_NFSE_FAILED: {
			return {
				...state,
				loading: { ...state.loading, cancel: false },
				errors: payload
			};
		}
		case actions.BULK_CANCEL_NFSE: {
			return {
				...state,
				loading: { ...state.loading, cancel: true },
				errors: initialState.errors
			};
		}
		case actions.BULK_CANCEL_NFSE_SUCCESS: {
			return {
				...state,
				loading: { ...state.loading, cancel: false }
			};
		}
		case actions.BULK_CANCEL_NFSE_FAILED: {
			return {
				...state,
				loading: { ...state.loading, cancel: false },
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
